import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule, PageMetaResolver, RoutingModule, UrlModule } from '@spartacus/core';
import { IconModule, KeyboardFocusModule, ListNavigationModule, SpinnerModule } from '@spartacus/storefront';
import { GenFavoritesListComponent } from './favorites-list/favorites-list.component';
import { RouterModule } from '@angular/router';
import { FavoritesListPageMetaResolver } from '../../resolvers/favorites-list-page-meta.resolver';
import { GenFavoritesNavigationComponent } from './favorites-navigation/favorites-navigation.component';
import { FavoritesConfirmActionDialogComponent } from './favorites-confirm-action-dialog/favorites-confirm-action-dialog.component';
import { GenCreateOrEditFavoritesListDialogComponent } from './create-or-edit-favorites-list-dialog/create-or-edit-favorites-list-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GenFavoriteProductsAddedToCartDialogComponent } from './favorite-products-added-to-cart-dialog/favorite-products-added-to-cart-dialog.component';
import { GenProductGridItemComponent } from '../product/product-list/product-grid-item/product-grid-item.component';

@NgModule({
  declarations: [ 
    GenFavoritesListComponent,
    GenFavoritesNavigationComponent,
    GenCreateOrEditFavoritesListDialogComponent,
    FavoritesConfirmActionDialogComponent,
    GenFavoriteProductsAddedToCartDialogComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    GenProductGridItemComponent,
    ListNavigationModule,
    UrlModule,
    RoutingModule,
    RouterModule,
    SpinnerModule,
    IconModule,
    KeyboardFocusModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  providers: [
    {
      provide: PageMetaResolver,
      useExisting: FavoritesListPageMetaResolver,
      multi: true,
    },
  ]
})
export class GenFavoritesModule {}
